module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.428f1389.ttf";